<template>
  <div class="app">
    <div class="div-background-loading" v-show="loadingMainPage">
      <loading-page></loading-page>
    </div>
    <AppHeader fixed style="background-color: #00a9fd !important;">
      <SidebarToggler class="d-lg-none" display="md" mobile/>
      <b-link class="navbar-brand" to="#">
        <img class="img-logo" src="../../public/logo-bancorbras.png" width="130"/>
      </b-link>
      <SidebarToggler id="btnSidebarHide" class="d-md-down-none" display="lg"/>
      <b-dropdown :text="hotelSelecionado.Id + ' - ' + hotelSelecionado.HotNome" class="m-md-2" :variant="'link'"
                  v-if="hoteisVinculados">
        <b-dropdown-item href="javascript:;"
                         v-for="(h, index) in hoteisVinculados"
                         @click="hotelSelecionado = h" v-bind:key="index"
                         v-show="hotelSelecionado.Id !== h.Id">
          {{h.Id}} - {{h.HotNome}}
        </b-dropdown-item>
      </b-dropdown>
      <div v-else-if="hotelSelecionado">
        <a class="btn" href="javascript:;">
          {{hotelSelecionado.Id}} - {{hotelSelecionado.HotNome}}
        </a>
        <button @click="selecionarOutroHotel()" class="btn btn-brand btn-sm btn-primary" type="button"
                style="margin-bottom: 4px">
          <i class="cui-account-logout icons"></i>
        </button>
      </div>
      <div>
        <!-- <a class="btn btn-danger" href="http://www.bancorbras.com.br/clube-de-turismo/calendario" target="_blank">
          <i class="nav-icon icon-calendar"></i>&nbsp;&nbsp;
          Calendário de reserva
        </a> -->
      </div>
      <b-navbar-nav class="ml-auto">
      </b-navbar-nav>
      <b-dropdown :text="nomeUsuarioLogado + ' '" class="m-md-2" :variant="'link'">
        <b-dropdown-item href="javascript:;" @click="RedirectToLogout()">
          Sair
        </b-dropdown-item>
      </b-dropdown>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" class="text-uppercase"/>
        <div class="container-fluid" v-if="startIframe">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <span class="mr-1">Bancorbrás Empreendimentos e Participações S.A.</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
  import TokenService from '../services/TokenService'
  import LoadingPage from '../views/layout/LoadingPage'
  import HotelService from '../services/HotelService'
  import LocalStorageService from '../services/LocalStorageService'
  import UtilService from '../services/UtilService'
  import LoginService from '../services/LoginService'

  import nav from '@/_nav'
  import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb
  } from '@coreui/vue'
  import DefaultAside from './DefaultAside'
  import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

  export default {
    name: 'DefaultContainer',
    components: {
      AsideToggler,
      AppHeader,
      AppSidebar,
      AppAside,
      TheFooter,
      Breadcrumb,
      DefaultAside,
      DefaultHeaderDropdownAccnt,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer,
      LoadingPage
    },
    data() {
      return {
        startIframe: false,
        nav: nav.items,
        loadingMainPage: false,
        hoteisVinculados: null,
        hotelSelecionado: null,
        nomeUsuarioLogado: '',
        menuFinanceiro: {
          name: 'Financeiro',
          url: '/',
          icon: 'fa fa-money fa-lg',
          children: [
            {
              name: 'Faturas',
              url: '/',
              icon: 'cui-dollar'
            }
          ]
        },
        menuGestaoUsuario: {
          id: 'usuario',
          name: 'Usuários',
          url: '/',
          icon: 'fa fa-user fa-lg'
        },
        eFuncionario: false
      }
    },
    created() {
      this.localStorageService = new LocalStorageService()
      this.tokenService = new TokenService()
      this.hotelService = new HotelService(this)
      this.tokenService.IniciarValidacao(this.callbackValidacaoAcesso)
      this.util = new UtilService(this)
      this.loginService = new LoginService()
    },
    mounted() {
      this.validarVisualizacaoFuncionario()
      this.util.VerificarHotelSelecionado(this.hotelSelecionado)
    },
    watch: {
      $route(to) {
        if (this.eFuncionario && to.query.hotel_id && to.query.hotel_name) {
          this.hotelSelecionado = {
            Id: to.query.hotel_id,
            HotNome: to.query.hotel_name,
            origemIFrame: true
          }
        }
      }
    },
    computed: {
      name() {
        return this.$route.name
      },
      list() {
        return this.$route.matched.filter((route) => route.name || route.meta.label)
      }
    },
    methods: {
      selecionarOutroHotel() {
        this.hotelSelecionado = null
        window.location.reload()
      },
      SelecionarHotel() {
        sessionStorage.removeItem("HOVEL_VINCULO_FUNCIONARIO")
        this.$router.push('/pages/login')
      },
      validarVisualizacaoFuncionario() {
        if (sessionStorage.getItem("HOVEL_VINCULO_FUNCIONARIO")) {
          let hotel = JSON.parse(sessionStorage.getItem("HOVEL_VINCULO_FUNCIONARIO"))
          this.hotelSelecionado = hotel
        }
        let cpf = this.localStorageService.Get(process.env.VUE_APP_CPF_LOGIN_ATUAL, true)        
        if (cpf) {
          this.loginService.VerificarPermissaoFuncionario(cpf, (res) => {            
            if (res) {             
              let funcionario = this.localStorageService.Get(process.env.VUE_APP_USUARIO_LOGADO)
              funcionario.eFuncionario = true
              this.localStorageService.Set(process.env.VUE_APP_USUARIO_LOGADO, funcionario)
              let result = this.nav.filter(x => x.name === this.menuFinanceiro.name)
              if (!result || result.length === 0) {
                this.nav.push(this.menuFinanceiro)                
              }
              let resultUsuario = this.nav.filter(x => x.name === this.menuGestaoUsuario.name)
              if(resultUsuario || resultUsuario.length === 0){
                this.nav.push(this.menuGestaoUsuario)
              }

              this.CarregarUsuarioCache()
              this.eFuncionario = true
            }
            setTimeout(() => {
              this.startIframe = true
            }, 1000)
          })
        } else {
          let ref = this
          setTimeout(() => {
            ref.validarVisualizacaoFuncionario()
            ref.CarregarUsuarioCache()
          }, 1000)
        }
      },
      RedirectToLogout() {
        this.util.RedirectLogout()
      },
      callbackValidacaoAcesso() {
        let cpf = this.localStorageService.Get(process.env.VUE_APP_CPF_LOGIN_ATUAL, true)
        this.hotelService.ListarHoteisVinculados({ "filtro" : btoa(cpf) }, this.callbackHoteisVinculados, this.callbackErro)       
        let claims = this.localStorageService.Get(process.env.VUE_APP_MY_CLAIMS)
        if(claims.filter(x => x.Value === 'verfatura').length > 0){
            let result = this.nav.filter(x => x.name === this.menuFinanceiro.name)
            if (!result || result.length === 0) {
              this.nav.push(this.menuFinanceiro, this.nav.length - 1)                
            }            
        }        
      },
      callbackHoteisVinculados(res) {
        if (res && res.length > 0) {
          this.hotelSelecionado = res[0]
          this.hoteisVinculados = res
          this.CarregarUsuarioCache()
          this.util.VerificarHotelSelecionado(this.hotelSelecionado)
        }
      },
      callbackErro(res) {
        alert('Nâo foi possível listar hotéis vinculados')
        this.CarregarUsuarioCache()
      },
      CarregarUsuarioCache() {
        let userCache = this.localStorageService.Get(process.env.VUE_APP_USUARIO_LOGADO)
        if (userCache) {
          this.nomeUsuarioLogado = userCache.NomePreferencia ? userCache.NomePreferencia.trim() : (userCache.Nome + userCache.Sobrenome)
        } else {
          let ref = this
          setTimeout(() => {
            ref.CarregarUsuarioCache()
          }, 1000)
        }
      }
    }
  }
</script>
<style>
  .nav-dropdown-items {
    padding-left: 15px !important;
    background: #012b56 !important;
    font-size: 12px !important;
  }

  .div-background-loading {
    position: fixed;
    background-color: #0000001c;
    height: 100%;
    top: 0;
    z-index: 9999;
    width: 100%;
  }

  .navbar-brand {
    background-color: #00a9fd;
  }

  .navbar {
    background-color: #00a9fd;
    border-bottom: 2px;
  }

  .navbar button {
    color: white !important;
  }

  .btn {
    color: #ffffff !important;
  }

  .sidebar {
    background: #004081;
  }

  .sidebar .nav-link {
    color: #ffff !important;
    background: #004081 !important;
  }

  .sidebar .nav-dropdown.open .nav-link {
    background: #012b56 !important;
  }

  .sidebar .nav-link.active .nav-icon {
    color: #ffff;
  }

  .sidebar .nav-link .nav-icon {
    color: #ffff;
  }

  .spinner div {
    background-color: #0096e1 !important;
  }

  .img-logo {
    margin-left: 15px;
  }

  .navbar-toggler {
    margin-left: 15px;
  }
</style>
